import { useMutation, useQueryClient } from 'react-query';

import { CommentReport } from '../../../types/CommentReport';
import Api from '../../api/api';

export const reinstateReportedComment = async (reportCommentId: string) => {
  const [response, bodyOrError] = await Api.patch(`comments/${reportCommentId}/reinstate-reported-comment`);

  if (!response.ok) {
    throw bodyOrError;
  }

  return bodyOrError;
};

export const useReinstateReportedComment = () => {
  const queryClient = useQueryClient();

  return useMutation<CommentReport, Error, string>('reinstateReportedComment', reinstateReportedComment, {
    onSuccess: () => {
      queryClient.invalidateQueries('reportedComments');
    },
  });
};
